import React, { useState } from 'react'
import { IAutocompleteOption } from 'transfix-ui/components/Autocomplete'
import {
  Autosuggest,
  getAutosuggestOptions,
  IAutosuggestWrapperProps,
} from 'transfix-ui/components/Autosuggest'
import searchCarrierTruckNumbers, {
  ITruckNumberSearch,
} from 'apps/marketplace/utils/api/carrierTruckNumbers'

interface ITruckAutosuggestProps extends IAutosuggestWrapperProps<string> {
  carrierId: string
  classNames?: string
}

/**
 * Truck Autosuggest from carrier's list of truck numbers
 * Used in marketplace, ie: Shipment List > Shipment Panel
 */
const TruckAutosuggest = ({
  carrierId,
  classNames = '',
  label = 'Truck',
  onBlur: onBlurProp,
  onChange: onChangeProp,
  value: valueProp,
  ...props
}: ITruckAutosuggestProps) => {
  const [truckSearchResults, setTruckSearchResults] = useState<IAutocompleteOption[] | undefined>(
    undefined
  )

  const fetchCarrierTruckNumbers = () => {
    if (!truckSearchResults) {
      searchCarrierTruckNumbers(carrierId).then(({ truckNumbers }) => {
        const optionsList = getAutosuggestOptions({
          options: truckNumbers,
          groupIndex: 1,
          mapOption: ({ id, value }: ITruckNumberSearch) => ({ id, text: value }),
        })

        setTruckSearchResults(optionsList)
      })
    }
  }

  const inputChangeHandler = (value: string) => onChangeProp(value)

  return (
    <div className={classNames}>
      <Autosuggest
        id='truck'
        dataTest='truck-number-autosuggest'
        value={valueProp}
        placeholder='Search by truck #'
        options={truckSearchResults}
        clearable
        label={label}
        onBlur={onBlurProp}
        onFocus={fetchCarrierTruckNumbers}
        onInputChange={inputChangeHandler}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...props}
      />
    </div>
  )
}

export default TruckAutosuggest
